import script from "./ProfileDdText.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileDdText.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileDdText.vue?vue&type=style&index=0&id=0d8cbc88&lang=css"

const __exports__ = script;

export default __exports__